<template>
  <div class="app-footer">
    <div class="app-footer__inner">
      <small>
        <ul class="nav">
          <li class="nav-item">
            <a class="nav-link text-light" href="https://www.ethicaltrade.org/privacy" target="_blank">Privacy policy</a>
          </li>
        </ul>
        <div>
          <a class="text-light" href="https://www.ethicaltrade.org" target="_blank">Ethical Trading Initiative</a> | Registered No. 3578127
        </div>
      </small>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AppFooter',
  }
</script>

<style src="./AppFooter.scss" lang="scss"></style>
